import isObject from 'lodash/isObject';
import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import every from 'lodash/every';
import { generateCheckedItemsInRange } from '@Containers/PatentFamilyClustering/utils';

export const mapResultItemToChecked = ({ index, id, details = {}, absoluteIndex, relativeIndex }) => ({
  index,
  id: id || details.id,
  absoluteIndex,
  relativeIndex,
});

export const mapProductToChecked = ({ substanceId, substanceIndex, productId, productIndex }) => ({
  substanceId,
  substanceIndex,
  productId,
  productIndex,
});

export const assertCheckedItems = (checkedItems) =>
  isObject(checkedItems) && !isEmpty(checkedItems) && every(Object.values(checkedItems), isArray);

export const mapAllResultsToChecked = (resultsItems) =>
  resultsItems.reduce((acc, item) => {
    const { index, absoluteIndex } = item;

    // Patent Family Clustering - main result item
    if (isArray(absoluteIndex)) {
      return acc.concat(generateCheckedItemsInRange(absoluteIndex, index));
    }

    return acc.concat([mapResultItemToChecked(item)]);
  }, []);
